"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ptCountry = void 0;
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var ptCountry = exports.ptCountry = function ptCountry(t) {
  return {
    id: 'PT',
    name: t('Portugal'),
    flag: '🇵🇹',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{4}-[0-9]{3}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: function zipcodeMatcher(zipCode, subZoneZipcode) {
      return zipCode.startsWith(subZoneZipcode);
    },
    zipcodePlaceholder: 'e.g. 1000-001 or 4000-001',
    phonePrefix: '351',
    phoneLength: 9,
    zipcodeHasLetters: true,
    pricingVersion: 14,
    timezone: 'Europe/Lisbon',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.PT,
      checker: _companyNumber.checkers.PT,
      placeholder: '500276722'
    }
  };
};